<template>
  <div class="estate-create">
    <header-top showBack></header-top>
    <div class="header-title show-back">添加楼盘</div>
    <div class="estate-main">
      <el-form
        label-position="left"
        label-width="5rem"
        ref="estateForm"
        :rules="estateRules"
        :model="estateForm"
      >
        <div class="estate-item">
          <div class="item-title">基础信息</div>
          <div class="item-main">
            <el-form-item label="项目地址" required class="min-input">
              <div class="flex-form">
                <el-form-item prop="city">
                  <el-select
                    v-model="estateForm.city"
                    filterable
                    remote
                    :remote-method="remoteMethod"
                    @change="cityChange"
                    clearable
                    placeholder="城市"
                  >
                    <el-option
                      v-for="item in cityOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="district">
                  <el-select
                    v-model="estateForm.district"
                    filterable
                    clearable
                    placeholder="县/区"
                    @change="districtChange"
                    :no-data-text="
                      estateForm.city ? '暂无数据' : '请先选择城市'
                    "
                  >
                    <el-option
                      v-for="item in districtOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id + '&$' + item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="street">
                  <el-select
                    v-model="estateForm.street"
                    clearable
                    filterable
                    placeholder="街道"
                    @change="streetChange"
                    :no-data-text="
                      estateForm.district ? '暂无数据' : '请先选择县/区'
                    "
                  >
                    <el-option
                      v-for="item in streetOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id + '&$' + item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="business">
                  <el-select
                    v-model="estateForm.business"
                    clearable
                    filterable
                    placeholder="商圈"
                    :no-data-text="
                      estateForm.street ? '暂无数据' : '请先选择街道'
                    "
                  >
                    <el-option
                      v-for="item in businessOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="realAddress" class="address-input">
                  <el-input
                    v-model="estateForm.realAddress"
                    placeholder="详细地址（40字以内）"
                    maxlength="40"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
            </el-form-item>
            <div class="flex-items">
              <div class="flex-item">
                <el-form-item label="楼盘名称" prop="name">
                  <el-input
                    v-model="estateForm.name"
                    placeholder="请输入楼盘名称"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="注册名称">
                  <el-input
                    v-model="estateForm.registerName"
                    placeholder="请输入注册名称"
                    clearable
                    maxlength="20"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="flex-item">
                <el-form-item label="推广名称" prop="promotionName">
                  <el-input
                    v-model="estateForm.promotionName"
                    placeholder="请输入推广名称"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="概要地址">
                  <el-input
                    v-model="estateForm.synopsisAddress"
                    placeholder="请输入概要地址"
                    maxlength="40"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <el-form-item
              label="楼盘定位"
              prop="locationAddress"
              class="auto-height"
            >
              <div class="location-tip" v-if="addressQuery.latitude">
                该楼盘已获取楼盘地址，你可以点击
                <span class="theme-color" @click="isShowAddress = true"
                  >重新定位</span
                >
                修改楼盘地址，也可以
                <span
                  class="theme-color del"
                  @click="
                    addressQuery = { address: '', latitude: '', longitude: '' };
                    estateForm.locationAddress = '';
                  "
                  >清除定位</span
                >。
              </div>
              <div class="location-tip" v-else>
                该楼盘暂未获取楼盘地址，你可以点击
                <span class="theme-color" @click="getAddress">获取定位</span>
                添加楼盘地址
              </div>
              <baidu-map
                v-if="addressQuery.latitude"
                :center="center"
                :zoom="zoom"
                @ready="showAddressHandler"
                id="showAddress"
                :scroll-wheel-zoom="true"
              ></baidu-map>
            </el-form-item>
            <div class="flex-items">
              <div class="flex-item">
                <el-form-item label="总价区间" required class="min-input">
                  <div class="flex-form">
                    <el-form-item prop="minTotalPrice">
                      <el-input
                        v-model="estateForm.minTotalPrice"
                        placeholder="请输入总价最小值"
                        type="number"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <span class="price-unit">-</span>
                    <el-form-item prop="maxTotalPrice">
                      <el-input
                        v-model="estateForm.maxTotalPrice"
                        placeholder="请输入总价最大值"
                        type="number"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <span class="price-unit">万元</span>
                  </div>
                </el-form-item>
                <el-form-item label="均价区间" required class="min-input">
                  <div class="flex-form">
                    <el-form-item prop="minPrice">
                      <el-input
                        v-model="estateForm.minPrice"
                        placeholder="请输入均价最小值"
                        type="number"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <span class="price-unit">-</span>
                    <el-form-item prop="maxPrice">
                      <el-input
                        v-model="estateForm.maxPrice"
                        placeholder="请输入均价最大值"
                        type="number"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <span class="price-unit">元/m²</span>
                  </div>
                </el-form-item>
                <el-form-item class="transfer-form-item" label="用途">
                  <div class="transfer-select" @click="openFiltrate">
                    <span
                      class="placeholder"
                      v-if="!estateForm.usingTypes.length"
                      >请选择用途</span
                    >
                    <div
                      class="select-item"
                      v-for="(item, index) in estateForm.usingTypes"
                      v-show="index < 3"
                      :key="index"
                    >
                      <span>{{ item }}</span>
                      <div
                        class="del-fixed-item"
                        @click.stop="delUseItem(index)"
                      >
                        <svg-icon icon-class="close-ico"></svg-icon>
                      </div>
                    </div>
                    <div v-if="estateForm.usingTypes.length > 3">...</div>
                    <div class="suffix">
                      <i
                        class="el-icon-circle-close"
                        @click.stop="estateForm.usingTypes = []"
                        v-if="estateForm.usingTypes.length"
                      ></i>
                      <i
                        class="el-icon-caret-bottom"
                        :class="{
                          'inline-block': !estateForm.usingTypes.length,
                        }"
                      ></i>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="开发商">
                  <el-input
                    v-model="estateForm.developerName"
                    placeholder="请输入开发商"
                    clearable
                    maxlength="40"
                  ></el-input>
                </el-form-item>
                <el-form-item label="售楼处电话" prop="salePhoneNumber">
                  <el-input
                    v-model="estateForm.salePhoneNumber"
                    placeholder="请输入售楼处电话"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="开盘时间">
                  <el-date-picker
                    align="center"
                    v-model="estateForm.launchTime"
                    type="date"
                    placeholder="请选择开盘时间"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="代理时间" class="time-item">
                  <el-date-picker
                    align="center"
                    v-model="estateForm.agentRange"
                    type="daterange"
                    range-separator="~"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="物业公司">
                  <el-input
                    v-model="estateForm.serviceCompany"
                    placeholder="请输入物业公司"
                    maxlength="20"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="物业地址">
                  <el-input
                    v-model="estateForm.serviceAddress"
                    placeholder="请输入物业地址"
                    maxlength="20"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
              <div class="flex-item">
                <el-form-item label="销售进度" prop="saleStatus">
                  <el-radio-group v-model="estateForm.saleStatus">
                    <el-radio
                      v-for="(item, key) in saleStatusOptions"
                      :label="key"
                      :key="key"
                      >{{ item }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="可住情况" prop="reside">
                  <el-radio-group v-model="estateForm.reside">
                    <el-radio
                      v-for="item in resideOptions"
                      :label="item.option"
                      :key="item.option"
                      >{{ item.option }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="建筑类型">
                  <el-radio-group v-model="estateForm.buildType">
                    <el-radio
                      v-for="item in buildTypeOptions"
                      :label="item.option"
                      :key="item.option"
                      >{{ item.option }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="售楼地址">
                  <el-input
                    v-model="estateForm.saleAddress"
                    placeholder="请输入售楼地址"
                    clearable
                    maxlength="40"
                  ></el-input>
                </el-form-item>
                <el-form-item label="交房时间">
                  <el-date-picker
                    align="center"
                    v-model="estateForm.deliveryTime"
                    type="date"
                    placeholder="请选择交房时间"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="竣工时间">
                  <el-date-picker
                    align="center"
                    v-model="estateForm.buildTime"
                    type="date"
                    placeholder="请选择竣工时间"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="物业电话" prop="servicePhoneNumber">
                  <el-input
                    v-model="estateForm.servicePhoneNumber"
                    placeholder="请输入物业电话"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="物业管理费">
                  <el-input
                    placeholder="请输入物业管理费"
                    v-model="estateForm.serviceFee"
                    type="number"
                  >
                  </el-input>
                  <span class="price-unit">元/㎡/月</span>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <div class="estate-item">
        <el-button type="primary" @click="submit" :loading="isLoading"
          >保存</el-button
        >
        <el-button @click="cance">取消</el-button>
      </div>
    </div>
    <el-dialog
      title="选择用途"
      :visible.sync="isFiltrateShow"
      :before-close="usesClose"
      custom-class="filter-dialog"
    >
      <el-transfer
        filterable
        :titles="['可选择用途', '已选择用途']"
        filter-placeholder="请输入用途名称"
        v-model="estateForm.usingTypes"
        :data="useTypes"
        :filter-method="filterMethod"
      ></el-transfer>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isFiltrateShow = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 获取定位 -->
    <el-dialog
      title="获取定位"
      :visible.sync="isShowAddress"
      :before-close="addressClose"
      width="800px"
      custom-class="add-filling address"
      @submit.native.prevent
    >
      <el-form :model="addressQuery" label-width="5rem" label-position="left">
        <el-form-item label="楼盘地址" class="auto-height">
          <el-input
            clearable
            @keyup.enter.native="changeAddress()"
            v-model="addressQuery.address"
            placeholder="请输入楼盘地址"
          ></el-input>
          <div class="map-group">
            <baidu-map
              v-if="addressQuery.address"
              :center="center"
              :zoom="zoom"
              @ready="handler"
              id="allmap"
              :scroll-wheel-zoom="true"
            ></baidu-map>
            <div class="address-list">
              <div class="select-tip" v-if="addressList.length">
                请选择楼盘地址<span class="rule-tip">*</span>
              </div>
              <div
                class="item"
                v-for="(item, index) in addressList"
                :key="index"
              >
                <div
                  class="marker"
                  :style="'background-position: -23px -' + 25 * index + 'px;'"
                ></div>
                <div class="info" @click="chooseAddress(item)">
                  <div>
                    <a :href="item.url" target="_blank">{{ item.title }}</a>
                  </div>
                  <div>地址：{{ item.address }}</div>
                  <div>坐标：{{ item.point.lng }},{{ item.point.lat }}</div>
                </div>
              </div>
              <div class="no-data" v-if="addressList.length == 0">
                暂无相关地点，请<span v-if="isEnterAddress">重新</span
                >输入楼盘地址
              </div>
            </div>
          </div>
        </el-form-item>
        <div class="error-tip" v-if="isAddressError">请选择楼盘地址</div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowAddress = false">取消</el-button>
        <el-button type="primary" @click="addressSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import { validatePhone, validaTelandlinePhone } from "@/utils/validate";
import { createEstate } from "@/http/api/estate";
import { dateFormat } from "@/common/filters";
import { areaSearchTree, areasSearch } from "@/http/api/area";
import { deepCopy } from "@/utils/deepCopy";
import { estateSettings, getTenantSettings } from "@/http/api/system";

export default {
  components: {
    headerTop,
  },
  data() {
    const validateTelPhoneNumber = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!(validatePhone(value) || validaTelandlinePhone(value))) {
        callback(new Error("电话号输入不正确"));
      } else {
        callback();
      }
    };
    const validateMinTotalPrice = (rule, value, callback) => {
      let max = this.estateForm.maxTotalPrice;
      if (!value) {
        callback(new Error("请输入总价最小值"));
      }
      if (Number(max) > 0 && Number(value) > Number(max)) {
        callback(new Error("总价最小值不能大于总价最大值"));
      } else {
        callback();
      }
    };
    const validateMaxTotalPrice = (rule, value, callback) => {
      let min = this.estateForm.minTotalPrice;
      if (!value) {
        callback(new Error("请输入总价最大值"));
      }
      if (Number(min) > 0 && Number(min) > Number(value)) {
        callback(new Error("总价最大值不能小于总价最小值"));
      } else {
        callback();
      }
    };
    const validateMinPrice = (rule, value, callback) => {
      let max = this.estateForm.maxPrice;
      if (!value) {
        callback(new Error("请输入均价最小值"));
      }
      if (Number(max) > 0 && Number(value) > Number(max)) {
        callback(new Error("均价最小值不能大于均价最大值"));
      } else {
        callback();
      }
    };
    const validateMaxPrice = (rule, value, callback) => {
      let min = this.estateForm.minPrice;
      if (!value) {
        callback(new Error("请输入均价最大值"));
      }
      if (Number(min) > 0 && Number(min) > Number(value)) {
        callback(new Error("均价最大值不能小于均价最小值"));
      } else {
        callback();
      }
    };
    return {
      //地图
      center: { lng: 109.45744048529967, lat: 36.49771311230842 },
      zoom: 13,
      isLoading: false,
      isFiltrateShow: false,
      isEnterAddress: false,
      isAddressError: false,
      // 添加地址
      addressList: [],
      isShowAddress: false,
      addressQuery: {
        address: "",
        latitude: "",
        longitude: "",
      },
      mapData: {},
      estateForm: {
        city: "",
        district: "",
        street: "",
        business: "",
        realAddress: "",
        synopsisAddress: "",
        name: "",
        registerName: "",
        promotionName: "",
        saleStatus: "",
        minPrice: "",
        maxPrice: "",
        sellingStartTime: "",
        sellingEndTime: "",
        usingTypes: [],
        agentRange: [],
        developerName: "",
        salePhoneNumber: "",
        launchTime: "",
        serviceCompany: "",
        serviceAddress: "",
        maxTotalPrice: "",
        minTotalPrice: "",
        buildType: "",
        saleAddress: "",
        reside: "",
        deliveryTime: "",
        buildTime: "",
        servicePhoneNumber: "",
        serviceFee: "",
        locationAddress: "",
        longitude: "",
        latitude: "",
      },
      estateRules: {
        city: [
          {
            required: true,
            trigger: "change",
            message: "请选择城市",
          },
        ],
        district: [
          {
            required: true,
            trigger: "change",
            message: "请选择县/区",
          },
        ],
        street: [
          {
            required: false,
          },
        ],
        business: [
          {
            required: false,
          },
        ],
        realAddress: [
          {
            required: true,
            trigger: "blur",
            message: "请输入详细地址",
          },
        ],
        name: [
          {
            required: true,
            trigger: "blur",
            message: "请输入楼盘名称",
          },
        ],
        promotionName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入推广名称",
          },
        ],
        minPrice: [
          {
            required: true,
            trigger: "blur",
            validator: validateMinPrice,
          },
        ],
        maxPrice: [
          {
            required: true,
            trigger: "blur",
            validator: validateMaxPrice,
          },
        ],
        minTotalPrice: [
          {
            required: true,
            trigger: "blur",
            validator: validateMinTotalPrice,
          },
        ],
        maxTotalPrice: [
          {
            required: true,
            trigger: "blur",
            validator: validateMaxTotalPrice,
          },
        ],
        saleStatus: [
          {
            required: true,
            trigger: "change",
            message: "请选择销售进度",
          },
        ],
        salePhoneNumber: [
          {
            required: false,
            trigger: "blur",
            validator: validateTelPhoneNumber,
          },
        ],
        servicePhoneNumber: [
          {
            required: false,
            trigger: "blur",
            validator: validateTelPhoneNumber,
          },
        ],
        locationAddress: [
          {
            required: true,
            message: "请获取楼盘定位",
          },
        ],
        reside: [
          {
            required: true,
            trigger: "change",
            message: "请选择可住情况",
          },
        ],
      },
      cityOptions: [],
      cityName: "",
      districtOptions: [],
      streetOptions: [],
      businessOptions: [],
      saleStatusOptions: this.$store.getters.enumMetadata.EstateSaleStatus,
      buildTypeOptions: [],
      resideOptions: [],
      useTypes: [],
    };
  },
  mounted() {
    this.getEstateSettings();
    this.areasSearch();
  },
  methods: {
    getEstateSettings() {
      estateSettings().then((res) => {
        res.result.map((item) => {
          if (item.name == "Deer.Estate.Collection.BuildType") {
            this.buildTypeOptions = item.value;
          } else if (item.name == "Deer.Estate.Collection.ResideType") {
            this.resideOptions = item.value;
          } else if (item.name == "Deer.Estate.Collection.UsingType") {
            item.value.map((type) => {
              this.useTypes.push({
                label: type.option,
                key: type.option,
              });
            });
          }
        });
      });
    },
    // 选择街道回调
    streetChange(v) {
      let id = v.split("&$")[0];
      if (id) {
        areaSearchTree({ parentId: id }).then((res) => {
          let arr = res.result.items;
          this.businessOptions = [];
          arr.map((el) => {
            this.businessOptions.push({
              name: el.data.name,
              id: el.data.id,
            });
          });
        });
      }
    },
    // 选择行政区回调
    districtChange(v) {
      let id = v.split("&$")[0];
      if (id) {
        areaSearchTree({ parentId: id }).then((res) => {
          let arr = res.result.items;
          this.streetOptions = [];
          arr.map((el) => {
            this.streetOptions.push({
              name: el.data.name,
              id: el.data.id,
            });
          });
        });
      }
    },
    // 选择城市回调
    cityChange(v) {
      this.districtOptions = [];
      areaSearchTree({ parentName: this.estateForm.city }).then((res) => {
        let arr = res.result.items;
        this.cityName = "";
        arr.map((el) => {
          this.districtOptions.push({
            name: el.data.name,
            id: el.data.id,
          });
        });
      });
    },
    // 获取城市项
    areasSearch() {
      // getTenantSettings().then((res) => {
      //   let arr = [];
      //   //console.log(res, 9888);
      //   res.result[0].value.map((item) => {
      //     arr.push(item.option);
      //   });
      //   this.cityOptions = deepCopy(arr);
      // });

      getTenantSettings().then((res) => {
          let arr = [];
          res.result.map(el=>{
              if (el.name=='Deer.Tenant.Collection.DomainArea') {
                  el.value.map(item=>{
                      arr.push(item.option);
                  })
              }
          })
          this.cityOptions = deepCopy(arr);
      });

      // let query = {
      //   type: "城市",
      //   filter: this.cityName,
      // };
      // areasSearch(query).then((res) => {
      //   this.cityOptions = res.result.items;
      // });
    },
    remoteMethod(val) {
      //console.log(val, 111222);
      this.cityName = val;
      this.areasSearch();
    },

    delUseItem(index) {
      this.estateForm.usingTypes.splice(index, 1);
    },
    addressClose() {
      this.isShowAddress = false;
    },
    getAddress() {
      this.isEnterAddress = false;
      this.addressQuery = {
        address: "",
        latitude: "",
        longitude: "",
      };
      this.addressList = [];
      this.isShowAddress = true;
    },
    // 添加地址
    addressSubmit() {
      //console.log(this.mapData);
      if (this.mapData && this.mapData.point && this.mapData.point.lat) {
        this.addressQuery.latitude = this.mapData.point.lat;
        this.addressQuery.longitude = this.mapData.point.lng;
        this.addressQuery.address = this.mapData.address;
        this.estateForm.locationAddress = this.addressQuery.address;
        this.isAddressError = false;
        this.$nextTick(() => {
          this.showAddressHandler();
          this.isShowAddress = false;
        });
      } else {
        this.isAddressError = true;
      }
    },
    //显示地址
    showAddressHandler() {
      var map = new BMap.Map("showAddress"); // 创建Map实例
      var point = new BMap.Point(
        this.addressQuery.longitude,
        this.addressQuery.latitude
      );
      map.centerAndZoom(point, 13);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
    },
    // 选择地址
    chooseAddress(res) {
      //console.log(res);
      this.addressQuery.address = res.address;
      this.mapData = res;
    },
    // 输入地址
    changeAddress() {
      this.isEnterAddress = true;
      this.handler();
    },
    handler() {
      var map = new BMap.Map("allmap"); // 创建Map实例
      map.centerAndZoom("郑州", 13);
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      var myGeo = new BMap.Geocoder();
      // 将地址解析结果显示在地图上,并调整地图视野
      var that = this;

      if (that.addressQuery.address) {
        var local = new BMap.LocalSearch(map, {
          renderOptions: { map: map },
        });
        local.search(this.addressQuery.address);
        //地址搜索后的回掉
        local.setSearchCompleteCallback((results) => {
          if (local.getStatus() == BMAP_STATUS_SUCCESS) {
            // 判断状态是否正确
            var s = [];
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              s.push(results.getPoi(i));
            }
            this.addressList = s;
          }
        });
      }
    },
    // 选择用途方法
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    // 打开穿梭框
    openFiltrate() {
      this.isFiltrateShow = true;
    },
    // 关闭穿梭框回调
    usesClose() {
      this.isFiltrateShow = false;
    },
    // 保存表单回调
    submit() {
      this.$refs["estateForm"].validate((valid) => {
        if (valid) {
          this.estateForm.sellingStartTime = dateFormat(
            this.estateForm.agentRange[0]
          );
          this.estateForm.sellingEndTime = dateFormat(
            this.estateForm.agentRange[1]
          );
          this.estateForm.launchTime = this.estateForm.launchTime
            ? dateFormat(this.estateForm.launchTime)
            : "";
          this.estateForm.deliveryTime = this.estateForm.deliveryTime
            ? dateFormat(this.estateForm.deliveryTime)
            : "";
          this.estateForm.buildTime = this.estateForm.buildTime
            ? dateFormat(this.estateForm.buildTime)
            : "";
          this.estateForm.longitude = this.addressQuery.longitude;
          this.estateForm.latitude = this.addressQuery.latitude;
          delete this.estateForm.agentRange;
          let data = deepCopy(this.estateForm);
          data.district = data.district.split("&$")[1];
          data.street = data.street.split("&$")[1];
          this.isLoading = true;
          createEstate(data)
            .then((res) => {
              if (res) {
                this.$message.success({
                  message: "保存成功",
                  showClose: true,
                });
              }
              this.isLoading = false;
              this.$router.push({ name: "estateList" });
            })
            .catch(() => {
              this.isLoading = false;
            });
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    cance() {
      this.$confirm(`您确定不保留数据回到列表页吗？`, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$router.push({ name: "estateList" });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";

.estate-create {
  .el-select,
  .el-input {
    width: 360px;
  }
  ::v-deep .el-date-editor {
    width: 360px !important;
    .el-icon-date {
      left: 320px;
    }
  }
  ::v-deep .time-item{
    .el-icon-date {
      left: 330px;
    }
  }
  .min-input {
    .el-select,
    .el-input {
      width: 170px;
    }
  }

  .estate-main {
    padding: 20px;
    .estate-item {
      background: #ffffff;
      border-radius: $--border-radius-base;

      &:first-child {
        margin-bottom: 20px;
      }

      &:nth-child(2) {
        padding: 20px;
        text-align: center;

        .el-button {
          width: 140px;
        }
      }

      .item-title {
        border-bottom: 1px solid #e0e0e0;
        padding: 20px;
        font-size: 16px;
        font-weight: bolder;
        color: #7d7d7d;
      }

      .item-main {
        padding: 20px;

        .location-tip {
          color: #9d9d9d;
        }

        .flex-form {
          display: flex;

          .el-select {
            margin-right: 10px;
          }

          .address-input {
            margin-left: 10px;
            width: 500px;
            .el-input {
              width: 100%;
            }
          }
        }

        .price-unit {
          margin: 0 7px;
        }

        .flex-items {
          display: flex;

          .flex-item {
            width: 50%;

            .transfer-select {
              width: 359px;
            }
          }
        }
      }
    }
  }

  #showAddress {
    margin-top: 24px;
    width: 100%;
    height: 341px;
  }

  .address {
    .el-input {
      width: 646px;
    }

    .map-group {
      width: 646px;
      height: 296px;
      margin-top: 10px;
      border: 1px solid #ddd;
      box-sizing: border-box;
      @include flex(row, center);
      #allmap {
        width: 382px;
        height: 100%;
      }

      .address-list {
        width: 262px;
        height: 100%;
        overflow-y: auto;

        .select-tip {
          padding-left: 10px;

          .rule-tip {
            display: inline-block;
            margin-left: 4px;
            color: #f56c6c;
          }
        }

        .no-data {
          color: #888;
          text-align: center;
        }
        .item {
          padding: 10px 7px 0;
          @include flex(row, flex-start);
          line-height: normal;
          .marker {
            width: 19px;
            height: 25px;
            margin-top: 2px;
            background: url(~@/assets/image/map-markers.png) no-repeat 0 0;
          }
          .info {
            width: 200px;
            margin-left: 4px;
            padding-top: 3px;
            padding-left: 2px;
            cursor: pointer;
            div {
              padding-bottom: 8px;
            }
            &:hover {
              background-color: #f0f0f0;
            }
          }
        }
      }
    }

    .el-form-item {
      margin-bottom: 0;
    }

    .error-tip {
      margin-left: 5rem;
      color: #f56c6c;
    }
  }
}
</style>